module.exports = __webpack_public_path__ + "img/hotstyleshow4.499348d4.jpg";